import React, { useState, useEffect } from 'react'

export default function LoadingDots() {
  const [dots, setDots] = useState([])
  useEffect(() => {
    const interval = setInterval(() => {
      console.log('Loading dot')
      if (dots.length < 3) {
        setDots([...dots, '.'])
      } else {
        setDots([])
      }
    }, 250)
    return () => clearInterval(interval)
  }, [dots])
  return <span>{dots.join('')}</span>
}